<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#E51020" type = "ball-clip-rotate" [fullScreen] = "true"></ngx-spinner>

<router-outlet></router-outlet>
<app-footer></app-footer>
